<ng-template #selecionarLote let-modal>
  <div class="modal-header">
    <h4 class="modal-title">Selecionar lote</h4>
    <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('close')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body">
    <div class="table-responsive tabela-modal-lote">
      <table class="table table-sm table-hover mb-0">
        <thead>
          <tr>
            <th>Lote</th>
            <th class="text-center">Estoque</th>
            <th class="text-center">Validade</th>
            <th class="text-right">Preço</th>
          </tr>
        </thead>
        <tbody>
          @for (produtoLote of produtosLotes; track produtoLote) {
            <tr class="linha-clicavel" (click)="selecionarLoteProduto(produtoLote.id)">
              <td>{{ produtoLote.nomelote }}</td>
              <td class="text-center">{{ produtoLote.estoque }}</td>
              <td class="text-center">{{ produtoLote.validade | date: 'dd/MM/yyyy' }}</td>
              <td class="text-right">{{ produtoLote.preco | currency: 'BRL' }}</td>
            </tr>
          }
        </tbody>
      </table>
    </div>
  </div>
</ng-template>

<!-- Modal: Produtos Selecionados para Importação em Massa -->
<ng-template #produtosAdicionadosEmMassaModal let-modal>
  <div class="modal-header">
    <h4 class="modal-title" id="titulo-produtos-adicionados-em-massa">
      Produtos Selecionados para Importação ({{ produtosSelecionadosBusca.size }})
    </h4>
    <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('close')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body">
    @if (produtosSelecionadosBusca.size === 0) {
      <div class="alert alert-info">
        Nenhum produto selecionado.
      </div>
    }

    @if (produtosSelecionadosBusca.size > 0) {
      <div class="table-responsive tabela-grid">
        <table class="table table-sm table-hover mb-0">
          <thead>
            <tr>
              <th></th>
              <th>Código</th>
              <th>Descrição</th>
              <th>Marca / Grupo</th>
              <th class="text-right">Preço Base</th>
            </tr>
          </thead>
          <tbody>
            @for (produto of produtosSelecionadosDetalhes; track trackByProdutoId($index, produto)) {
              <tr>
                <td class="text-center">
                  <button class="btn btn-link btn-link-action danger" type="button"
                    (click)="selecionarProdutoBusca(produto.id)" title="Desselecionar">
                    &times;
                  </button>
                </td>
                <td>{{ produto.codigo }}</td>
                <td>{{ produto.name }}</td>
                <td>{{ produto.grupo_estoque }}</td>
                <td class="text-right">{{ (produto.price > 0 ? produto.price : produto.custo) | currency: 'BRL' }}</td>
              </tr>
            }
          </tbody>
        </table>
      </div>
    }
  </div>

  <div class="modal-footer">
    <button class="btn btn-outline-secondary" type="button" (click)="modal.close('close')">Fechar</button>
  </div>
</ng-template>

@if (!carregando) {
  <div class="campanha-page" [@esvanecerDesvanecer]="'in'">
    <div class="page-header">
      <div>
        <h1>{{ produtoCampanha == null ? 'Nova Campanha' : 'Alterar Campanha' }}</h1>
        <p>Migre o padrão de Promoções para Campanhas com importação, edição em massa e gestão de vínculos.</p>
      </div>
      <button class="btn btn-success btn-header" type="button" (click)="salvarProdutoCampanha()" [disabled]="salvando">
        {{ salvando ? 'Salvando...' : 'Salvar campanha' }}
      </button>
    </div>
    <div class="stepper">
      <button type="button" class="step" [class.active]="itemSelecionado === 0" (click)="alterarItemSelecionado(0)">1. Informações</button>
      <button type="button" class="step" [class.active]="itemSelecionado === 1" (click)="alterarItemSelecionado(1)">2. Imagem</button>
      <button type="button" class="step" [class.active]="itemSelecionado === 2" (click)="alterarItemSelecionado(2)">3. Produtos</button>
      @if (usaPromocao) {
        <button type="button" class="step" [class.active]="itemSelecionado === 3" (click)="alterarItemSelecionado(3)">4. Clientes</button>
      }
      @if (usaPromocao) {
        <button type="button" class="step" [class.active]="itemSelecionado === 4" (click)="alterarItemSelecionado(4)">5. Vendedores</button>
      }
      <!-- Aba "Regras de Grupo" desativada a pedido. Para reativar, troque a condição por: usaPromocao && produtoCampanha?.id -->
      @if (false) {
        <button type="button" class="step" [class.active]="itemSelecionado === 5" (click)="alterarItemSelecionado(5)">6. Regras de Grupo</button>
      }
    </div>
    @if (itemSelecionado === 0) {
      <section class="card-section" [@desvanecer]="'in'">
        <div class="section-title">
          <h2>Informações gerais</h2>
        </div>
        <form [formGroup]="formProdutoCampanha">
          <div class="form-grid cols-4">
            <div class="field field-span-2">
              <label>Nome</label>
              <input class="form-control" type="text" formControlName="nome" [ngClass]="{ 'is-invalid': enviadoProdutoCampanha && fpc.nome.errors?.required }" />
              @if (enviadoProdutoCampanha && fpc.nome.errors?.required) {
                <div class="invalid-feedback d-block">Informe o nome da campanha.</div>
              }
            </div>
            <div class="field">
              <label>Ativo</label>
              <select class="form-control" (change)="selecionarProdutoCampanhaAtivo($event.target.value)">
                <option value="1" [selected]="produtoCampanhaAtivo">Sim</option>
                <option value="0" [selected]="!produtoCampanhaAtivo">Não</option>
              </select>
            </div>
            <div class="field">
              <label>ID externo</label>
              <input class="form-control" type="number" formControlName="id_no_erp_do_cliente" />
            </div>
            <div class="field">
              <label>Kit / Combo</label>
              <select class="form-control" (change)="selecionarProdutoCampanhaKitCombo($event.target.value)" [disabled]="produtosCampanhaItens.length > 0">
                <option value="K" [selected]="produtoCampanhaKitCombo === 'K'">Kit</option>
                <option value="C" [selected]="produtoCampanhaKitCombo === 'C'">Combo</option>
              </select>
            </div>
            <div class="field">
              <label>Preço / Bonificação</label>
              <select class="form-control" (change)="selecionarProdutoCampanhaPrecoBonificacao($event.target.value)" [disabled]="produtoCampanha != null">
                <option value="P" [selected]="produtoCampanhaPrecoBonificacao === 'P'">Preço</option>
                <option value="B" [selected]="produtoCampanhaPrecoBonificacao === 'B'">Bonificação</option>
              </select>
            </div>
            @if (produtoCampanhaKitCombo === 'C') {
              <div class="field">
                <label>Quantidade mínima</label>
                <input class="form-control" type="number" min="1" formControlName="qtde" [ngClass]="{ 'is-invalid': enviadoProdutoCampanha && fpc.qtde.errors?.required }" />
                @if (enviadoProdutoCampanha && fpc.qtde.errors?.required) {
                  <div class="invalid-feedback d-block">Informe a quantidade mínima.</div>
                }
              </div>
            }
            @if (produtoCampanhaPrecoBonificacao === 'B') {
              <div class="field">
                <label>Bonificação multiplicável</label>
                <select class="form-control" (change)="selecionarProdutoCampanhaBonificacaoMultiplicavel($event.target.value)">
                  <option value="1" [selected]="produtoCampanhaBonificacaoMultiplicavel">Sim</option>
                  <option value="0" [selected]="!produtoCampanhaBonificacaoMultiplicavel">Não</option>
                </select>
              </div>
            }
            @if (produtoCampanhaPrecoBonificacao === 'B') {
              <div class="field">
                <label>Bonificação selecionável</label>
                <select class="form-control" (change)="selecionarProdutoCampanhaBonificacaoSelecionavel($event.target.value)">
                  <option value="1" [selected]="produtoCampanhaBonificacaoSelecionavel">Sim</option>
                  <option value="0" [selected]="!produtoCampanhaBonificacaoSelecionavel">Não</option>
                </select>
              </div>
            }
            <div class="field">
              <label>Data início (itens)</label>
              <input class="form-control" type="date" [(ngModel)]="dataInicioProdutos" [ngModelOptions]="{standalone: true}" />
            </div>
            <div class="field">
              <label>Data fim (itens)</label>
              <input class="form-control" type="date" [(ngModel)]="dataFimProdutos" [ngModelOptions]="{standalone: true}" />
            </div>
          </div>
        </form>
        <div class="section-actions right">
          <button class="btn btn-primary" type="button" (click)="prosseguirItemSelecionado(0)">Prosseguir</button>
        </div>
      </section>
    }
    @if (itemSelecionado === 1) {
      <section class="card-section" [@desvanecer]="'in'">
        <div class="section-title">
          <h2>Imagem da campanha</h2>
          <p>PNG com fundo transparente e até 60 KB.</p>
        </div>
        <div class="form-grid cols-2 align-start">
          <div class="field">
            <label>Arquivo</label>
            <input #arquivoImagem class="form-control" type="file" accept="image/png" (change)="uploadCampanhaImagem($event)" />
            <div class="helper-text">Resolução ideal: 210x210.</div>
            @if (campanhaImagemErro) {
              <div class="invalid-feedback d-block">Arquivo acima de 60 KB.</div>
            }
            @if (campanhaImagemInvalida) {
              <div class="invalid-feedback d-block">Arquivo inválido.</div>
            }
          </div>
          @if (campanhaImagem !== '') {
            <div class="preview-card">
              <img class="campanha_imagem" [src]="campanhaImagem" alt="Preview da campanha" />
              <button class="btn btn-outline-danger btn-sm mt-3" type="button" (click)="removerCampanhaImagem()">Remover imagem</button>
            </div>
          }
        </div>
        <div class="section-actions between">
          <button class="btn btn-outline-secondary" type="button" (click)="retornarItemSelecionado(1)">Retornar</button>
          <button class="btn btn-primary" type="button" (click)="prosseguirItemSelecionado(1)">Prosseguir</button>
        </div>
      </section>
    }
    @if (itemSelecionado === 2) {
      <section class="card-section" [@desvanecer]="'in'">
        <div class="section-title">
          <h2>Produtos da campanha</h2>
          <p>Filtre, selecione em massa, importe por planilha e ajuste os itens inline.</p>
        </div>
        <!-- Modal: Item da Campanha -->
        <ng-template #modalItemCampanha let-modal>
          <div class="modal-header">
            <h4 class="modal-title" id="titulo-item-campanha">
              {{ produtoCampanhaItemSelecionadoIndex !== -1 ? 'Editar item' : 'Adicionar item' }}
              @if (produtoSelecionado) {
                <span class="modal-item-nome"> — {{ produtoSelecionado.codigo }} {{ produtoSelecionado.name }}</span>
              }
            </h4>
            <button type="button" class="close" (click)="fecharModalItemCampanha()">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <form [formGroup]="formProdutoCampanhaItem">
              <div class="form-grid cols-2">
                <div class="field">
                  <label>Código</label>
                  <input class="form-control" type="text" [value]="produtoSelecionado?.codigo || ''" disabled />
                </div>
                <div class="field">
                  <label>Descrição</label>
                  <input class="form-control" type="text" [value]="produtoSelecionado?.name || ''" disabled />
                </div>
                <div class="field">
                  <label>Ativo</label>
                  <select class="form-control" (change)="selecionarProdutoCampanhaItemAtivo($event.target.value)">
                    <option value="1" [selected]="produtoCampanhaItemAtivo">Sim</option>
                    <option value="0" [selected]="!produtoCampanhaItemAtivo">Não</option>
                  </select>
                </div>
                @if (produtoCampanhaPrecoBonificacao === 'B' && produtoCampanhaBonificacaoSelecionavel) {
                  <div class="field">
                    <label>Bonificação</label>
                    <select class="form-control" (change)="selecionarProdutoCampanhaItemBonificacao($event.target.value)">
                      <option value="0" [selected]="!produtoCampanhaItemBonificacao">Não</option>
                      <option value="1" [selected]="produtoCampanhaItemBonificacao">Sim</option>
                    </select>
                  </div>
                }
                @if (produtoSelecionado != null && produtoSelecionado.qtde_lote > 0) {
                  <div class="field">
                    <label>Lote</label>
                    <div class="input-with-button">
                      <input class="form-control" type="text" [value]="produtoSelecionado.nome_lote" disabled />
                      <button class="btn btn-outline-secondary" type="button" (click)="modalSelecionarLote(selecionarLote, produtoSelecionado.id)">Lotes</button>
                    </div>
                    @if (produtoLoteErro) {
                      <div class="invalid-feedback d-block">Selecione um lote.</div>
                    }
                  </div>
                }
                <div class="field">
                  <label>Quantidade</label>
                  <input class="form-control" type="number" formControlName="qtde" />
                </div>
                <div class="field">
                  <label>Preço base</label>
                  <input class="form-control" type="text" [value]="produtoSelecionado?.valor | currency: 'BRL'" disabled />
                </div>
                <div class="field">
                  <label>Tipo cálculo</label>
                  <select class="form-control" formControlName="tipo_calculo" (change)="onModalTipoCalculoChange()">
                    <option value="">Sem cálculo</option>
                    <option value="margem">Margem</option>
                    <option value="desconto">Desconto</option>
                  </select>
                </div>
                <div class="field">
                  <label>Percentual</label>
                  <input class="form-control" type="number" formControlName="tipo_percentual" (input)="onModalPercentualChange()" />
                </div>
                <div class="field">
                  <label>Preço final</label>
                  <input class="form-control" type="number" formControlName="preco" (input)="onModalPrecoChange()" />
                </div>
              </div>
            </form>
            @if (produtoEmBranco || produtoInvalido) {
              <div class="alert alert-danger mt-3 mb-0">
                {{ produtoEmBranco ? 'Selecione um produto antes de salvar.' : 'O produto já está incluído na campanha.' }}
              </div>
            }
          </div>
          <div class="modal-footer">
            <button class="btn btn-outline-secondary" type="button" (click)="fecharModalItemCampanha()">Cancelar</button>
            <button class="btn btn-success" type="button" (click)="salvarItemModal()">Salvar item</button>
          </div>
        </ng-template>
        <div class="panel">
          <div class="panel-header"><h3>Busca de produtos</h3></div>
          <!-- Filtro com chips — valor é select dinâmico para campos com opções -->
          <form [formGroup]="formFiltroProduto" class="filter-row" (ngSubmit)="adicionarFiltroProduto()">
            <div class="filter-field-group">
              <select class="form-control form-control-sm filter-select-campo"
                formControlName="filtro" (change)="alterarFiltroProdutoSelecionado()">
                @for (opcao of filtroProdutos; track opcao) {
                  <option [value]="opcao.valor">{{ opcao.texto }}</option>
                }
              </select>
              <!-- Input de texto para campos sem opções pré-definidas -->
              @if (!filtroValorEhSelect) {
                <input
                  class="form-control form-control-sm filter-input-valor"
                  type="text" formControlName="valor"
                  placeholder="Valor do filtro..."
                  [ngClass]="{ 'is-invalid': enviadoProduto && ffp.valor.errors?.required }" />
              }
              <!-- Select dinâmico para marca/subgrupos -->
              @if (filtroValorEhSelect) {
                <select
                  class="form-control form-control-sm filter-input-valor"
                  formControlName="valor"
                  [ngClass]="{ 'is-invalid': enviadoProduto && ffp.valor.errors?.required }">
                  <option value="">-- Selecione --</option>
                  @for (op of opcoesValorFiltro; track op) {
                    <option [value]="op">{{ op }}</option>
                  }
                </select>
              }
            </div>
            <button class="btn btn-sm btn-primary" type="submit">+ Adicionar filtro</button>
            <button class="btn btn-sm btn-success" type="button" (click)="filtrarProduto()" [disabled]="filtrosAtivosProdutos.length === 0">Filtrar</button>
            <button class="btn btn-sm btn-outline-secondary" type="button" (click)="limparTodosFiltrosProdutos()">Limpar</button>
          </form>
          <!-- Chips de filtros ativos -->
          @if (filtrosAtivosProdutos.length > 0) {
            <div class="chips">
              @for (filtro of filtrosAtivosProdutos; track filtro; let i = $index) {
                <span class="chip">
                  {{ obterTextoFiltroProduto(filtro.tipo) }}: <b>{{ filtro.valor }}</b>
                  <button type="button" (click)="removerFiltroProduto(i)">&times;</button>
                </span>
              }
              <small class="text-muted align-self-center ml-2">{{ produtos.length }} produto(s)</small>
            </div>
          }
          @if (filtrosAtivosProdutos.length === 0 && produtos.length === 0) {
            <small class="text-muted d-block mb-2"
              >
              Use os filtros acima e clique em <b>Filtrar</b> para listar os produtos.
            </small>
          }
          <!-- Botão para visualizar selecionados -->
          @if (produtosSelecionadosBusca.size > 0) {
            <div class="mb-3">
              <button class="btn btn-warning" type="button"
                (click)="abrirModalProdutosSelecionados(produtosAdicionadosEmMassaModal)">
                👁️ Visualizar ({{ produtosSelecionadosBusca.size }}) selecionado(s)
              </button>
              <button class="btn btn-outline-danger ml-2" type="button" (click)="produtosSelecionadosBusca.clear()">
                Limpar seleção
              </button>
            </div>
          }
          <!-- Toolbar de importação em massa -->
          <div class="bulk-toolbar">
            <div class="bulk-fields-labeled">
              <div class="bulk-field-item">
                <label>Qtde mínima</label>
                <input class="form-control form-control-sm" type="number" [(ngModel)]="quantidadeMinimaProdutos" [ngModelOptions]="{standalone: true}" />
              </div>
              <div class="bulk-field-item">
                <label>Tipo de cálculo</label>
                <select class="form-control form-control-sm" [(ngModel)]="tipoCalculo" [ngModelOptions]="{standalone: true}" (ngModelChange)="tipoCalculo === '' && (percentualProdutos = 0)">
                  <option value="">Sem cálculo</option>
                  <option value="margem">Margem</option>
                  <option value="desconto">Desconto</option>
                </select>
              </div>
              <div class="bulk-field-item">
                <label>Percentual (%)</label>
                <input class="form-control form-control-sm" type="number" [(ngModel)]="percentualProdutos" [ngModelOptions]="{standalone: true}" />
              </div>
              <div class="bulk-field-item">
                <label>Ativo</label>
                <select class="form-control form-control-sm" [(ngModel)]="importarProdutosAtivos" [ngModelOptions]="{standalone: true}">
                  <option [ngValue]="true">Ativo</option>
                  <option [ngValue]="false">Inativo</option>
                </select>
              </div>
            </div>
            <button class="btn btn-success" type="button" (click)="importarProdutosSelecionados()">Importar selecionados</button>
          </div>
          <div class="table-responsive tabela-grid tabela-grid-scroll">
            <table class="table table-sm table-hover mb-0">
              <thead>
                <tr>
                  <th class="check-col"><input type="checkbox" [checked]="estaTodosProdutosBuscaSelecionados()" (change)="selecionarTodosProdutosBusca()" /></th>
                  <th>Código</th>
                  <th>Descrição</th>
                  <th>Marca / Grupo</th>
                  <th>Subgrupo 1</th>
                  <th class="text-right">Preço</th>
                  <!-- <th class="text-right">Ação</th> -->
                </tr>
              </thead>
              <tbody>
                @for (produto of produtos; track trackByProdutoId($index, produto)) {
                  <tr>
                    <td><input type="checkbox" [checked]="estaProdutoSelecionadoBusca(produto.id)" (change)="selecionarProdutoBusca(produto.id)" /></td>
                    <td>{{ produto.codigo }}</td>
                    <td>{{ produto.name }}</td>
                    <td>{{ produto.grupo_estoque }}</td>
                    <td>{{ produto.subgrupo_estoque }}</td>
                    <td class="text-right">{{ produto.price | currency: 'BRL' }}</td>
                    <!-- <td class="text-right">
                    <button class="btn btn-link btn-link-action" type="button"
                      (click)="abrirModalItemCampanha(produto.id, modalItemCampanha)">
                      Adicionar / editar
                    </button>
                  </td> -->
                </tr>
              }
              @if (produtos.length === 0) {
                <tr>
                  <td colspan="6" class="text-center text-muted py-4">
                    @if (filtrosAtivosProdutos.length === 0) {
                      <span>Use os filtros acima e clique em <b>Filtrar</b> para listar os produtos.</span>
                    }
                    @if (filtrosAtivosProdutos.length > 0) {
                      <span>Nenhum produto encontrado com os filtros informados.</span>
                    }
                  </td>
                </tr>
              }
            </tbody>
          </table>
        </div>
      </div>
      <div class="panel mt-4">
        <div class="panel-header"><h3>Importação por arquivo</h3></div>
        <div class="import-box">
          <input class="form-control" type="file" accept=".xlsx,.xls,.csv" (change)="onArquivoImportacaoSelecionado($event)" />
          <div class="import-actions">
            <button class="btn btn-outline-primary" type="button" (click)="baixarModeloImportacao()">Baixar modelo</button>
            <button class="btn btn-success" type="button" (click)="confirmarImportacaoArquivo()">Confirmar importação</button>
            <button class="btn btn-outline-secondary" type="button" (click)="limparImportacaoArquivo()">Limpar</button>
          </div>
          @if (importacaoErroUpload) {
            <div class="invalid-feedback d-block">{{ importacaoErroUpload }}</div>
          }
          @if (importacaoProcessando) {
            <div class="helper-text">Processando arquivo...</div>
          }
          @if (importacaoLinhasValidas.length > 0) {
            <div class="helper-text">Linhas válidas: {{ importacaoLinhasValidas.length }}</div>
          }
          @if (importacaoLinhasInvalidas.length > 0) {
            <div class="helper-text text-danger">Linhas inválidas: {{ importacaoLinhasInvalidas.length }}</div>
          }
        </div>
      </div>
      <div class="panel mt-4">
        <div class="panel-header"><h3>Itens da campanha</h3></div>
        <div class="bulk-toolbar">
          <div class="bulk-fields-labeled">
            <div class="bulk-field-item">
              <label>Ativo</label>
              <select class="form-control form-control-sm" [(ngModel)]="edicaoEmMassaItens.is_active" [ngModelOptions]="{standalone: true}">
                <option [ngValue]="null">Todos</option>
                <option [ngValue]="true">Ativo</option>
                <option [ngValue]="false">Inativo</option>
              </select>
            </div>
            <div class="bulk-field-item">
              <label>Qtde</label>
              <input class="form-control form-control-sm" type="number" [(ngModel)]="edicaoEmMassaItens.qtdade" [ngModelOptions]="{standalone: true}" />
            </div>
            <div class="bulk-field-item">
              <label>Tipo de cálculo</label>
              <select class="form-control form-control-sm" [(ngModel)]="edicaoEmMassaItens.tipo_calculo" [ngModelOptions]="{standalone: true}">
                <option [ngValue]="null">Todos</option>
                <option value="margem">Margem</option>
                <option value="desconto">Desconto</option>
              </select>
            </div>
            <div class="bulk-field-item">
              <label>Percentual (%)</label>
              <input class="form-control form-control-sm" type="number" [(ngModel)]="edicaoEmMassaItens.tipo_percentual" [ngModelOptions]="{standalone: true}" />
            </div>
            <div class="bulk-field-item">
              <label>Preço</label>
              <input class="form-control form-control-sm" type="number" [(ngModel)]="edicaoEmMassaItens.preco" [ngModelOptions]="{standalone: true}" />
            </div>
          </div>
          <div class="bulk-actions">
            <button class="btn btn-primary" type="button" (click)="aplicarEdicaoEmMassaItens()">Aplicar edição em massa</button>
            <button class="btn btn-outline-secondary" type="button" (click)="limparEdicaoEmMassaItens()">Limpar</button>
            <button class="btn btn-outline-danger" type="button" (click)="removerItensSelecionadosEmMassa()">Remover selecionados</button>
          </div>
        </div>
        <div class="table-responsive tabela-grid">
          <table class="table table-sm table-hover mb-0">
            <thead>
              <tr>
                <th class="check-col"><input type="checkbox" [checked]="estaTodosProdutosCampanhaSelecionados()" (change)="selecionarTodosProdutosCampanhaTabela()" /></th>
                <th>Código</th>
                <th>Produto</th>
                <th class="text-center">Qtde</th>
                <th class="text-center">Tipo</th>
                <th class="text-right">%</th>
                <th class="text-right">Preço</th>
                <th class="text-center">Ativo</th>
                <th class="text-right">Ações</th>
              </tr>
            </thead>
            <tbody>
              @for (item of produtosCampanhaItens; track item; let i = $index) {
                <tr
                  [class.tr-editando]="itemEmEdicao?.index === i">
                  <td><input type="checkbox" [checked]="estaProdutoCampanhaSelecionado(i)" (change)="selecionarProdutoCampanhaTabela(i)" /></td>
                  <td>{{ item.codigo }}</td>
                  <td>
                    <div class="item-title">{{ item.name }}</div>
                    @if (item.nome_lote) {
                      <div class="item-subtitle">Lote: {{ item.nome_lote }}</div>
                    }
                  </td>
                  <!-- Qtde — editável inline -->
                  <td class="text-center td-editavel" title="Clique para editar"
                    (click)="iniciarEdicaoItem(i, 'qtdade')">
                    @if (!estaEditandoItem(i, 'qtdade')) {
                      <span>{{ item.qtdade }}</span>
                    }
                    @if (estaEditandoItem(i, 'qtdade')) {
                      <input
                        type="number" class="form-control form-control-sm item-edit-focus"
                        [(ngModel)]="item.qtdade" [ngModelOptions]="{standalone: true}"
                        (blur)="finalizarEdicaoItem(i, 'qtdade')"
                        (keyup.enter)="finalizarEdicaoItem(i, 'qtdade')"
                        (keyup.escape)="cancelarEdicaoItem()"
                        style="width: 70px; display: inline-block;" autofocus />
                    }
                  </td>
                  <!-- Tipo cálculo — editável inline -->
                  <td class="text-center td-editavel" title="Clique para editar"
                    (click)="iniciarEdicaoItem(i, 'tipo_calculo')">
                    @if (!estaEditandoItem(i, 'tipo_calculo')) {
                      <span class="text-uppercase">
                        {{ item.tipo_calculo || '-' }}
                      </span>
                    }
                    @if (estaEditandoItem(i, 'tipo_calculo')) {
                      <select
                        class="form-control form-control-sm item-edit-focus"
                        [(ngModel)]="item.tipo_calculo" [ngModelOptions]="{standalone: true}"
                        (change)="finalizarEdicaoItem(i, 'tipo_calculo')"
                        (blur)="finalizarEdicaoItem(i, 'tipo_calculo')"
                        (keyup.escape)="cancelarEdicaoItem()"
                        style="width: 110px; display: inline-block;" autofocus>
                        <option value="">Sem cálculo</option>
                        <option value="margem">Margem</option>
                        <option value="desconto">Desconto</option>
                      </select>
                    }
                  </td>
                  <!-- % — editável inline, recalcula preço -->
                  <td class="text-right td-editavel" title="Clique para editar (recalcula preço)"
                    (click)="iniciarEdicaoItem(i, 'tipo_percentual')">
                    @if (!estaEditandoItem(i, 'tipo_percentual')) {
                      <span>
                        {{ item.tipo_percentual || 0 | number: '1.0-2' }}%
                      </span>
                    }
                    @if (estaEditandoItem(i, 'tipo_percentual')) {
                      <input
                        type="number" class="form-control form-control-sm item-edit-focus"
                        [(ngModel)]="item.tipo_percentual" [ngModelOptions]="{standalone: true}"
                        (ngModelChange)="recalcularPrecoItem(item)"
                        (blur)="finalizarEdicaoItem(i, 'tipo_percentual')"
                        (keyup.enter)="finalizarEdicaoItem(i, 'tipo_percentual')"
                        (keyup.escape)="cancelarEdicaoItem()"
                        style="width: 80px; display: inline-block;" autofocus />
                    }
                  </td>
                  <!-- Preço — editável inline, recalcula % -->
                  <td class="text-right td-editavel" title="Clique para editar (recalcula %)"
                    (click)="iniciarEdicaoItem(i, 'preco')">
                    @if (!estaEditandoItem(i, 'preco')) {
                      <span>{{ item.preco | currency: 'BRL' }}</span>
                    }
                    @if (estaEditandoItem(i, 'preco')) {
                      <input
                        type="number" class="form-control form-control-sm item-edit-focus"
                        [(ngModel)]="item.preco" [ngModelOptions]="{standalone: true}"
                        (ngModelChange)="recalcularPercentualItem(item)"
                        (blur)="finalizarEdicaoItem(i, 'preco')"
                        (keyup.enter)="finalizarEdicaoItem(i, 'preco')"
                        (keyup.escape)="cancelarEdicaoItem()"
                        style="width: 100px; display: inline-block;" autofocus />
                    }
                  </td>
                  <!-- Ativo — editável inline -->
                  <td class="text-center td-editavel" title="Clique para editar"
                    (click)="iniciarEdicaoItem(i, 'is_active')">
                    @if (!estaEditandoItem(i, 'is_active')) {
                      <span
                        [class.badge-ativo]="item.is_active" [class.badge-inativo]="!item.is_active">
                        {{ item.is_active ? 'Sim' : 'Não' }}
                      </span>
                    }
                    @if (estaEditandoItem(i, 'is_active')) {
                      <select
                        class="form-control form-control-sm item-edit-focus"
                        [(ngModel)]="item.is_active" [ngModelOptions]="{standalone: true}"
                        (change)="finalizarEdicaoItem(i, 'is_active')"
                        (blur)="finalizarEdicaoItem(i, 'is_active')"
                        (keyup.escape)="cancelarEdicaoItem()"
                        style="width: 90px; display: inline-block;" autofocus>
                        <option [ngValue]="true">Sim</option>
                        <option [ngValue]="false">Não</option>
                      </select>
                    }
                  </td>
                  <td class="text-right actions-col">
                    <button class="btn btn-link btn-link-action" type="button" title="Editar item"
                      (click)="abrirModalEditarItemCampanha(i, modalItemCampanha)">
                      <i class="fa fa-eye"></i>
                    </button>
                    <button class="btn btn-link btn-link-action danger" type="button" title="Remover item" (click)="removerProdutoCampanhaItem(i)">
                      <i class="fa fa-trash"></i>
                    </button>
                  </td>
                </tr>
              }
              @if (produtosCampanhaItens.length === 0) {
                <tr>
                  <td colspan="9" class="text-center text-muted py-4">Nenhum item adicionado à campanha.</td>
                </tr>
              }
            </tbody>
          </table>
        </div>
      </div>
    </section>
  }
  @if (usaPromocao && itemSelecionado === 3) {
    <section class="card-section" [@desvanecer]="'in'">
      <div class="section-title">
        <h2>Clientes vinculados</h2>
        <p>Disponível apenas quando a configuração usa promoções.</p>
      </div>
      <div class="panel">
        <form [formGroup]="formFiltroCliente" class="filter-row" (ngSubmit)="adicionarFiltroCliente()">
          <div class="filter-field-group">
            <select class="form-control form-control-sm filter-select-campo"
              formControlName="filtro" (change)="alterarFiltroClienteSelecionado()">
              @for (opcao of filtroClientes; track opcao) {
                <option [value]="opcao.valor">{{ opcao.texto }}</option>
              }
            </select>
            @if (!filtroValorClienteEhSelect) {
              <input
                class="form-control form-control-sm filter-input-valor"
                type="text" formControlName="valor" placeholder="Valor do filtro..."
                [ngClass]="{ 'is-invalid': enviadoCliente && ffc.valor.errors?.required }" />
            }
            @if (filtroValorClienteEhSelect) {
              <select
                class="form-control form-control-sm filter-input-valor"
                formControlName="valor"
                [ngClass]="{ 'is-invalid': enviadoCliente && ffc.valor.errors?.required }">
                <option value="">-- Selecione --</option>
                @for (op of opcoesValorFiltroCliente; track op) {
                  <option [value]="op">{{ op }}</option>
                }
              </select>
            }
          </div>
          <button class="btn btn-sm btn-primary" type="submit">+ Adicionar filtro</button>
          <button class="btn btn-sm btn-success" type="button" (click)="filtrarCliente()" [disabled]="filtrosAtivosClientes.length === 0">Filtrar</button>
          <button class="btn btn-sm btn-outline-secondary" type="button" (click)="limparTodosFiltrosClientes()">Limpar</button>
        </form>
        @if (filtrosAtivosClientes.length > 0) {
          <div class="chips">
            @for (filtro of filtrosAtivosClientes; track filtro; let i = $index) {
              <span class="chip">
                {{ obterTextoFiltroCliente(filtro.tipo) }}: <b>{{ filtro.valor }}</b>
                <button type="button" (click)="removerFiltroCliente(i)">&times;</button>
              </span>
            }
            <small class="text-muted align-self-center ml-2">{{ clientes.length }} cliente(s)</small>
          </div>
        }
        @if (filtrosAtivosClientes.length === 0 && clientes.length === 0) {
          <small class="text-muted d-block mb-2">
            Use os filtros acima e clique em <b>Filtrar</b> para listar os clientes.
          </small>
        }
        <div class="bulk-toolbar">
          <button class="btn btn-success" type="button" (click)="importarClientesSelecionados()">Vincular clientes selecionados</button>
        </div>
        <div class="virtual-table-container">
          <table class="table table-sm mb-0 virtual-table-header">
            <colgroup>
            <col style="width: 42px" />
            <col style="width: 100px" />
            <col />
            <col style="width: 160px" />
            <col style="width: 160px" />
          </colgroup>
          <thead>
            <tr>
              <th class="check-col"><input type="checkbox" [checked]="estaTodosClientesBuscaSelecionados()" (change)="selecionarTodosClientesBusca()" /></th>
              <th>Código</th>
              <th>Nome</th>
              <th>Cidade</th>
              <th>Segmento</th>
            </tr>
          </thead>
        </table>
        <cdk-virtual-scroll-viewport [itemSize]="38" class="virtual-scroll-viewport">
          <table class="table table-sm table-hover mb-0 virtual-table-body">
            <colgroup>
            <col style="width: 42px" />
            <col style="width: 100px" />
            <col />
            <col style="width: 160px" />
            <col style="width: 160px" />
          </colgroup>
          <tbody>
            <tr *cdkVirtualFor="let cliente of clientes; trackBy: trackByClienteId">
              <td><input type="checkbox" [checked]="estaClienteSelecionadoBusca(cliente.id)" (change)="selecionarClienteBusca(cliente.id)" /></td>
              <td>{{ cliente.codigo_no_erp_do_cliente }}</td>
              <td>{{ cliente.name }}</td>
              <td>{{ cliente.cidade }}</td>
              <td>{{ cliente.segment }}</td>
            </tr>
            @if (clientes.length === 0) {
              <tr>
                <td colspan="5" class="text-center text-muted py-4">Use os filtros acima e clique em <b>Filtrar</b> para listar os clientes.</td>
              </tr>
            }
          </tbody>
        </table>
      </cdk-virtual-scroll-viewport>
    </div>
  </div>
  <div class="panel mt-4">
    <div class="panel-header d-flex justify-content-between align-items-center">
      <h3>Clientes já vinculados <span class="badge badge-secondary">{{ clientesCampanha.length }}</span></h3>
      <button class="btn btn-sm btn-outline-danger" type="button"
        [disabled]="clientesCampanhaSelecionados.size === 0"
        (click)="removerClientesCampanhaEmMassa()">
        <i class="fa fa-trash"></i> Remover selecionados
      </button>
    </div>
    <div class="tabela-grid tabela-grid-scroll">
      <table class="table table-sm table-hover mb-0">
        <thead>
          <tr>
            <th class="check-col"><input type="checkbox" [checked]="estaTodosClientesCampanhaSelecionados()" (change)="selecionarTodosClientesCampanha()" /></th>
            <th>Nome</th>
            <th class="text-right">Ação</th>
          </tr>
        </thead>
        <tbody>
          @for (cliente of clientesCampanha; track cliente; let i = $index) {
            <tr>
              <td><input type="checkbox" [checked]="estaClienteCampanhaSelecionado(cliente.idcliente)" (change)="selecionarClienteCampanha(cliente.idcliente)" /></td>
              <td>{{ cliente.name }}</td>
              <td class="text-right"><button class="btn btn-link btn-link-action danger" type="button" title="Remover cliente" (click)="removerClienteCampanha(i)"><i class="fa fa-trash"></i></button></td>
            </tr>
          }
          @if (clientesCampanha.length === 0) {
            <tr>
              <td colspan="3" class="text-center text-muted py-4">Nenhum cliente vinculado.</td>
            </tr>
          }
        </tbody>
      </table>
    </div>
  </div>
</section>
}
@if (usaPromocao && itemSelecionado === 4) {
  <section class="card-section" [@desvanecer]="'in'">
    <div class="section-title"><h2>Vendedores vinculados</h2></div>
    <div class="panel">
      <form [formGroup]="formFiltroVendedor" class="filter-row" (ngSubmit)="adicionarFiltroVendedor()">
        <div class="filter-field-group">
          <select class="form-control form-control-sm filter-select-campo"
            formControlName="filtro" (change)="alterarFiltroVendedorSelecionado()">
            @for (opcao of filtroVendedores; track opcao) {
              <option [value]="opcao.valor">{{ opcao.texto }}</option>
            }
          </select>
          @if (!filtroValorVendedorEhSelect) {
            <input
              class="form-control form-control-sm filter-input-valor"
              type="text" formControlName="valor" placeholder="Valor do filtro..."
              [ngClass]="{ 'is-invalid': enviadoVendedor && ffv.valor.errors?.required }" />
          }
          @if (filtroValorVendedorEhSelect) {
            <select
              class="form-control form-control-sm filter-input-valor"
              formControlName="valor"
              [ngClass]="{ 'is-invalid': enviadoVendedor && ffv.valor.errors?.required }">
              <option value="">-- Selecione --</option>
              @for (op of opcoesValorFiltroVendedor; track op) {
                <option [value]="op">{{ op }}</option>
              }
            </select>
          }
        </div>
        <button class="btn btn-sm btn-primary" type="submit">+ Adicionar filtro</button>
        <button class="btn btn-sm btn-success" type="button" (click)="filtrarVendedor()" [disabled]="filtrosAtivosVendedores.length === 0">Filtrar</button>
        <button class="btn btn-sm btn-outline-secondary" type="button" (click)="limparTodosFiltrosVendedores()">Limpar</button>
      </form>
      @if (filtrosAtivosVendedores.length > 0) {
        <div class="chips">
          @for (filtro of filtrosAtivosVendedores; track filtro; let i = $index) {
            <span class="chip">
              {{ obterTextoFiltroVendedor(filtro.tipo) }}: <b>{{ filtro.valor }}</b>
              <button type="button" (click)="removerFiltroVendedor(i)">&times;</button>
            </span>
          }
          <small class="text-muted align-self-center ml-2">{{ vendedores.length }} vendedor(es)</small>
        </div>
      }
      @if (filtrosAtivosVendedores.length === 0 && vendedores.length === 0) {
        <small class="text-muted d-block mb-2">
          Use os filtros acima e clique em <b>Filtrar</b> para listar os vendedores ({{ vendedoresOriginal.length }} disponíveis).
        </small>
      }
      <div class="bulk-toolbar">
        <button class="btn btn-success" type="button" (click)="importarVendedoresSelecionados()">Vincular vendedores selecionados</button>
      </div>
      <div class="virtual-table-container">
        <table class="table table-sm mb-0 virtual-table-header">
          <colgroup>
          <col style="width: 42px" />
          <col style="width: 100px" />
          <col />
          <col style="width: 160px" />
          <col style="width: 140px" />
        </colgroup>
        <thead>
          <tr>
            <th class="check-col"><input type="checkbox" [checked]="estaTodosVendedoresBuscaSelecionados()" (change)="selecionarTodosVendedoresBusca()" /></th>
            <th>Código</th>
            <th>Nome</th>
            <th>Empresa</th>
            <th>Equipe</th>
          </tr>
        </thead>
      </table>
      <cdk-virtual-scroll-viewport [itemSize]="38" class="virtual-scroll-viewport">
        <table class="table table-sm table-hover mb-0 virtual-table-body">
          <colgroup>
          <col style="width: 42px" />
          <col style="width: 100px" />
          <col />
          <col style="width: 160px" />
          <col style="width: 140px" />
        </colgroup>
        <tbody>
          <tr *cdkVirtualFor="let vendedor of vendedores; trackBy: trackByVendedorId">
            <td><input type="checkbox" [checked]="estaVendedorSelecionadoBusca(vendedor.id)" (change)="selecionarVendedorBusca(vendedor.id)" /></td>
            <td>{{ vendedor.codigo_no_erp_do_cliente }}</td>
            <td>{{ vendedor.fullname }}</td>
            <td>{{ vendedor.nm_empresa }}</td>
            <td>{{ vendedor.nome_equipe }}</td>
          </tr>
          @if (vendedores.length === 0) {
            <tr>
              <td colspan="5" class="text-center text-muted py-4">Use os filtros acima e clique em <b>Filtrar</b> para listar os vendedores.</td>
            </tr>
          }
        </tbody>
      </table>
    </cdk-virtual-scroll-viewport>
  </div>
</div>
<div class="panel mt-4">
  <div class="panel-header d-flex justify-content-between align-items-center">
    <h3>Vendedores já vinculados <span class="badge badge-secondary">{{ vendedoresCampanha.length }}</span></h3>
    <button class="btn btn-sm btn-outline-danger" type="button"
      [disabled]="vendedoresCampanhaSelecionados.size === 0"
      (click)="removerVendedoresCampanhaEmMassa()">
      <i class="fa fa-trash"></i> Remover selecionados
    </button>
  </div>
  <div class="tabela-grid tabela-grid-scroll">
    <table class="table table-sm table-hover mb-0">
      <thead>
        <tr>
          <th class="check-col"><input type="checkbox" [checked]="estaTodosVendedoresCampanhaSelecionados()" (change)="selecionarTodosVendedoresCampanha()" /></th>
          <th>Nome</th>
          <th class="text-right">Ação</th>
        </tr>
      </thead>
      <tbody>
        @for (vendedor of vendedoresCampanha; track vendedor; let i = $index) {
          <tr>
            <td><input type="checkbox" [checked]="estaVendedorCampanhaSelecionado(vendedor.idseller)" (change)="selecionarVendedorCampanha(vendedor.idseller)" /></td>
            <td>{{ vendedor.fullname }}</td>
            <td class="text-right"><button class="btn btn-link btn-link-action danger" type="button" title="Remover vendedor" (click)="removerVendedorCampanha(i)"><i class="fa fa-trash"></i></button></td>
          </tr>
        }
        @if (vendedoresCampanha.length === 0) {
          <tr>
            <td colspan="3" class="text-center text-muted py-4">Nenhum vendedor vinculado.</td>
          </tr>
        }
      </tbody>
    </table>
  </div>
</div>
</section>
}
<!-- Step 5: Regras de Grupo -->
@if (itemSelecionado === 5 && usaPromocao && produtoCampanha?.id) {
  <div class="mt-3">
    @if (regrasGrupoCarregando) {
      <div class="text-center py-3"><i class="fas fa-spinner fa-spin"></i> Carregando...</div>
    }

    <!-- Clientes por Grupo -->
    <h6 class="font-weight-bold mb-2">Clientes por Grupo</h6>
    <div class="form-row align-items-end mb-2">
      <div class="col-auto">
        <select class="form-control form-control-sm" [(ngModel)]="rgCampoCliente" (change)="carregarValoresCliente()">
          <option value="">Campo...</option>
          @for (c of camposCliente; track c.campo) {
            <option [value]="c.campo">{{ c.label }}</option>
          }
        </select>
      </div>
      <div class="col-auto">
        <select class="form-control form-control-sm" [(ngModel)]="rgValorCliente"
          [disabled]="!rgCampoCliente || rgValoresClienteCarregando">
          <option value="">{{ rgValoresClienteCarregando ? 'Carregando...' : 'Valor...' }}</option>
          @for (v of rgValoresCliente; track v) {
            <option [value]="v">{{ v }}</option>
          }
        </select>
      </div>
      <div class="col-auto">
        <button class="btn btn-sm btn-primary" [disabled]="!rgCampoCliente || !rgValorCliente"
          (click)="adicionarRegraGrupoCliente()">
          <i class="fas fa-plus"></i> Adicionar
        </button>
      </div>
    </div>
    <div class="table-responsive tabela-grid mb-4">
      <table class="table table-sm table-hover mb-0">
        <thead>
          <tr><th>Campo</th><th>Valor</th><th></th></tr>
        </thead>
        <tbody>
          @for (r of regrasGrupoClientes; track r.id) {
            <tr>
              <td>{{ r.campo }}</td>
              <td>{{ r.valor }}</td>
              <td class="text-right">
                <button class="btn btn-link btn-link-action danger" type="button" title="Remover regra" (click)="removerRegraGrupo(r.id)">
                  <i class="fa fa-trash"></i>
                </button>
              </td>
            </tr>
          } @empty {
            <tr><td colspan="3" class="text-center text-muted py-2">Nenhuma regra de cliente cadastrada.</td></tr>
          }
        </tbody>
      </table>
    </div>

    <!-- Produtos por Grupo -->
    <h6 class="font-weight-bold mb-2">Produtos por Grupo</h6>
    <div class="form-row align-items-end mb-2">
      <div class="col-auto">
        <select class="form-control form-control-sm" [(ngModel)]="rgCampoProduto" (change)="carregarValoresProduto()">
          <option value="">Campo...</option>
          @for (c of camposProduto; track c.campo) {
            <option [value]="c.campo">{{ c.label }}</option>
          }
        </select>
      </div>
      <div class="col-auto">
        <select class="form-control form-control-sm" [(ngModel)]="rgValorProduto"
          [disabled]="!rgCampoProduto || rgValoresProdutoCarregando">
          <option value="">{{ rgValoresProdutoCarregando ? 'Carregando...' : 'Valor...' }}</option>
          @for (v of rgValoresProduto; track v) {
            <option [value]="v">{{ v }}</option>
          }
        </select>
      </div>
      <div class="col-auto">
        <input class="form-control form-control-sm" type="number" min="1" placeholder="Qtd"
          [(ngModel)]="rgQtdProduto" style="width:70px" />
      </div>
      <div class="col-auto">
        <select class="form-control form-control-sm" [(ngModel)]="rgTipoProduto">
          <option value="">Tipo...</option>
          <option value="desconto">Desconto</option>
          <option value="margem">Margem</option>
        </select>
      </div>
      <div class="col-auto">
        <input class="form-control form-control-sm" type="number" min="0" max="100" step="0.01"
          placeholder="%" [(ngModel)]="rgPercentualProduto" style="width:70px" />
      </div>
      <div class="col-auto">
        <button class="btn btn-sm btn-primary"
          [disabled]="!rgCampoProduto || !rgValorProduto || !rgQtdProduto || !rgTipoProduto || rgPercentualProduto == null"
          (click)="adicionarRegraGrupoProduto()">
          <i class="fas fa-plus"></i> Adicionar
        </button>
      </div>
    </div>
    <div class="table-responsive tabela-grid">
      <table class="table table-sm table-hover mb-0">
        <thead>
          <tr><th>Campo</th><th>Valor</th><th>Qtd</th><th>Tipo</th><th>%</th><th></th></tr>
        </thead>
        <tbody>
          @for (r of regrasGrupoProdutos; track r.id) {
            <tr>
              <td>{{ r.campo }}</td>
              <td>{{ r.valor }}</td>
              <td>{{ r.qtd }}</td>
              <td>{{ r.tipo_preco }}</td>
              <td>{{ r.percentual }}%</td>
              <td class="text-right">
                <button class="btn btn-link btn-link-action danger" type="button" title="Remover regra" (click)="removerRegraGrupo(r.id)">
                  <i class="fa fa-trash"></i>
                </button>
              </td>
            </tr>
          } @empty {
            <tr><td colspan="3" class="text-center text-muted py-2">Nenhuma regra de produto cadastrada.</td></tr>
          }
        </tbody>
      </table>
    </div>
  </div>
}
</div>
}

@if (carregando) {
  <div class="loading-state">
    <div class="spinner-border text-primary" role="status"></div>
    <span>Carregando campanha...</span>
  </div>
}
